import { render } from "./DoctorsList.vue?vue&type=template&id=421e9f73&scoped=true"
import script from "./DoctorsList.vue?vue&type=script&lang=ts"
export * from "./DoctorsList.vue?vue&type=script&lang=ts"

import "./DoctorsList.vue?vue&type=style&index=0&id=421e9f73&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-421e9f73"

export default script